import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	flagged: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	flagged: {
		id: 'native-issue-table.common.issue-cells.flag.flagged',
		defaultMessage: 'Impediment',
		description: 'Message shown when an issue has been flagged as important or blocked.',
	},
});
export default messages;
